module.exports = __webpack_public_path__ + "img/2_of_Diamonds.svg.4aacb0eb.png";